import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import bowser from 'bowser';
import debounce from 'lodash/debounce';
import './style.scss';
import AppExample from '../../../assets/img/app-example.png';
import { ReactComponent as BtnCerrar } from '../../../assets/icons/icon.svg';

const appBannerCookie = 'app-banner';

const BannerApp = () => {
  const [cookies, setCookie] = useCookies([appBannerCookie]);
  const [visible, setVisible] = useState(false);

  const getLink = useCallback(() => {
    if (bowser.ios || bowser.mac) {
      return 'https://itunes.apple.com/es/app/onda-cero-radio/id437480425?mt=8';
    }
    return 'https://play.google.com/store/apps/details?id=com.antena3.ondaceroradio&hl=es';
  }, []);

  const close = () => {
    const maxAge = 30 * 24 * 60 * 60;
    setCookie(appBannerCookie, 'true', { maxAge });
  };

  const handleScroll = useRef(
    debounce(() => {
      // if (window.scrollY > 100) {
      setVisible(true);
      // }
    }, 200)
  ).current;

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    !cookies[appBannerCookie] && (
      <div className={`bannerApp ${visible ? 'bannerApp_visible' : ''}`}>
        <img
          className="bannerApp_img"
          src={AppExample}
          alt="aplicación de Onda Cero"
        />
        <div className="bannerApp_text">
          <p>¿Tienes ya la app de Onda Cero?</p>
          <a href={getLink()}>
            <button type="button" className="button">
              DESCARGAR
            </button>
          </a>
        </div>
        <BtnCerrar className="bannerApp_close" onClick={close} />
      </div>
    )
  );
};

export default BannerApp;
